import React from 'react'

const Courses = () => {
      const courses = [
  {
    title: "Kali Linux asoslari",
    description: "Kiberxavfsizlik sohasiga ilk qadamlar",
    price: "0",
    
    video: "https://www.youtube.com/embed/2eebptXfEvw",

    lessons: [
      { id: 1, title: "Kirish" },
      { id: 2, title: "O‘rnatish" },
      { id: 3, title: "Terminal" }
    ]
  },
  {
    title: "AyTida kasb tanlash: amaliy 30 kun",
    description: "AyTidagi yo`nalishlarni tartibli ko`rib chiqing. Turli kasblar bilan tanishing.",
    price: 499000,
    
    video: "https://www.youtube.com/embed/2eebptXfEvw",

    lessons: [
      { id: 1, title: "Kirish" },
      { id: 2, title: "O‘rnatish" },
      { id: 3, title: "Terminal" }
    ]
  },
  {
    title: "SI start: kodlarsiz",
    description: "Sun’iy intellekt haqida aniq va to`g`ri tasavvur hosil qiling.",
    price: 990000,
    
    video: "https://www.youtube.com/embed/2eebptXfEvw",

    lessons: [
      { id: 1, title: "Kirish" },
      { id: 2, title: "O‘rnatish" },
      { id: 3, title: "Terminal" }
    ]
  },
  {
    title: "Ilk qadam",
    description: "Sohaga qadamlarni to`g`ri tashlang. Hammasini sinab ko`rib, eng mosini tanlang.",
    price: "0",
    
    video: "https://www.youtube.com/embed/2eebptXfEvw",

    lessons: [
      { id: 1, title: "Kirish" },
      { id: 2, title: "O‘rnatish" },
      { id: 3, title: "Terminal" }
    ]
  },
  {
    title: "Git asoslari",
    description: "Kurs orqali dasturchilar hayotida katta rol o`ynaydigan Git sistemasini o`rganing.",
    price: 297000,
    
    video: "https://www.youtube.com/embed/2eebptXfEvw",

    lessons: [
      { id: 1, title: "Kirish" },
      { id: 2, title: "O‘rnatish" },
      { id: 3, title: "Terminal" }
    ]
  },
  {
    title: "Professional Node.js: noldan boshlab e’lonlar sayti yaratish",
    description: "Kurs soha bo`yicha barcha kerakli bilimlarni o`zida jamlagan bo`lib...",
    price: 247000 ,
    
    video: "https://www.youtube.com/embed/2eebptXfEvw",

    lessons: [
      { id: 1, title: "Kirish" },
      { id: 2, title: "O‘rnatish" },
      { id: 3, title: "Terminal" }
    ]
  },
  {
    title: "Python dasturlash asoslari",
    description: "Python dasturlash tilini mukammal darslik asosida o`rganing.",
    price: "0",
    
    video: "https://www.youtube.com/embed/2eebptXfEvw",

    lessons: [
      { id: 1, title: "Kirish" },
      { id: 2, title: "O‘rnatish" },
      { id: 3, title: "Terminal" }
    ]
  },
  {
    title: "Django 3 – Pythonda Full stack Web dasturlash",
    description: "Kurs orqali frontend va backendni bog`lash, foydalanuvchilar bilan ishlashni o`rganing.",
    price: "0",
    
    video: "https://www.youtube.com/embed/2eebptXfEvw",

    lessons: [
      { id: 1, title: "Kirish" },
      { id: 2, title: "O‘rnatish" },
      { id: 3, title: "Terminal" }
    ]
  },
];
  return (
    <div>
  <div className="kurslar">
          
        {courses.map((a,index)=>(
          <div className="controle">
          <div className="card" key={index}>

 <div className="image">
  {a.title}
</div>
  <div className="content">
   <h2>{a.title}</h2>

    <p className="desc">
      {a.description}
    </p>
    <h2>{a.price}SUM</h2>

    <a className="action"  href='/videos'>
      Find out more
      <span aria-hidden="true">
        →
      </span>
    </a>

  </div>

          </div>
          </div>
        ))}
        </div>
    </div>
  )
}

export default Courses